import React from "react";
import { FiAlertTriangle, FiLogOut } from "react-icons/fi";
import api from "../../api/api";

export const ImpersonationBanner: React.FC = () => {
  const isImpersonating = sessionStorage.getItem("is_impersonating") === "true";
  const companyName = sessionStorage.getItem("impersonating_company_name") || "Tenant";

  if (!isImpersonating) {
    return null;
  }

  const handleExitImpersonation = async (): Promise<void> => {
    // Revoke the server-side impersonation token before switching back.
    try {
      await api.post("/impersonation/stop");
    } catch {
      // Even if revocation fails, restore the local super-admin session.
    }

    const originalToken = sessionStorage.getItem("super_admin_original_token");
    if (originalToken) {
      localStorage.setItem("token", originalToken);
    }
    sessionStorage.removeItem("is_impersonating");
    sessionStorage.removeItem("impersonating_company_name");
    sessionStorage.removeItem("super_admin_original_token");

    window.location.assign("/super-admin");
  };

  return (
    <div className="bg-amber-500 text-slate-950 px-4 py-2 text-xs font-bold flex items-center justify-between shadow-md z-50 sticky top-0">
      <div className="flex items-center gap-2">
        <FiAlertTriangle className="w-4 h-4 text-slate-950" />
        <span>
          Support Mode: You are currently impersonating <u>{companyName}</u> with administrative privileges.
        </span>
      </div>
      <button
        onClick={() => {
          void handleExitImpersonation();
        }}
        className="px-3 py-1 bg-slate-950 hover:bg-slate-900 text-white rounded-md font-bold transition-all inline-flex items-center gap-1 shadow-sm"
      >
        <FiLogOut className="w-3.5 h-3.5" /> Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
